export default "__VITE_PUBLIC_ASSET__6fb84440__"